module.exports = __webpack_public_path__ + "img/CompScope_Space_01.54f746df.png";